import t from"sanitize-html";const o={allowedTags:["b","i","u","font","img"],allowedAttributes:{img:["alt","src"],font:["color"]}},i=(i,l=o)=>t(i,l);export{i as sanitizeDangerousHTML};
